import React, { Component } from "react";

class CurrentRoom extends Component {
	render() {
		let { roomData, changeObj } = this.props;

		// let roomChanges = changeObj.filter(
		// 	(f) => f.roomId == roomData.unreal_id
		// )[0];
		let roomName;
		let sumPrice;

		function calcSum() {
			sumPrice = 0;
			if (changeObj) {
				let changesArr = changeObj.changeObj.filter(
					(f) => f.roomId == roomData.unreal_id
				)[0].selectedChoice;

				for (let i = 0; i < changesArr.length; i++) {
					sumPrice += changesArr[i].choice.surcharge;
				}
			}
		}

		let additionalPrice = 0;

		if (changeObj) {
			for (let i = 0; i < changeObj.changeObj.length; i++) {
				for (let j = 0; j < changeObj.changeObj[i].selectedChoice.length; j++) {
					additionalPrice +=
						changeObj.changeObj[i].selectedChoice[j].choice.surcharge;
				}
			}
		}

		if (roomData) {
			roomName = roomData.label.de;
			calcSum();
			// console.log(roomChanges);
		} else {
			roomName = "-";
			sumPrice = 0;
		}

		return (
			<div className="roomLabel">
				<span>{roomName}</span>
				<span>
					{"+ " +
						sumPrice.toLocaleString(undefined, {
							maximumFractionDigits: 0,
						}) +
						" €"}
				</span>
			</div>
		);
	}
}

export default CurrentRoom;
